var map = {
	".": 58834,
	"./": 58834,
	"./GraphQLLanguageService": 18418,
	"./GraphQLLanguageService.js": 18418,
	"./GraphQLLanguageService.js.flow": 9588,
	"./autocompleteUtils": 65484,
	"./autocompleteUtils.js": 65484,
	"./autocompleteUtils.js.flow": 82317,
	"./getAutocompleteSuggestions": 97727,
	"./getAutocompleteSuggestions.js": 97727,
	"./getAutocompleteSuggestions.js.flow": 53184,
	"./getDefinition": 18440,
	"./getDefinition.js": 18440,
	"./getDefinition.js.flow": 16889,
	"./getDiagnostics": 514,
	"./getDiagnostics.js": 514,
	"./getDiagnostics.js.flow": 36885,
	"./getHoverInformation": 51139,
	"./getHoverInformation.js": 51139,
	"./getHoverInformation.js.flow": 20466,
	"./getOutline": 11973,
	"./getOutline.js": 11973,
	"./getOutline.js.flow": 81801,
	"./index": 58834,
	"./index.js": 58834,
	"./index.js.flow": 75988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60544;